
// region JS Imports

// region External Modules
import $ from "jquery"
import { EventEmitter } from "events"

import URI from "urijs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


export interface Selector {
  scope:  string
  main:   string

  area_menu_toggle:   string
  area_menu_dropdown: string

  link: string
}
export interface InputSelector {
  scope?:  string
  main?:   string

  area_menu_toggle?:   string
  area_menu_dropdown?: string

  link?: string
}

const DEFAULT_SELECTOR = {
  scope: ".main-navbar-desktop",
  main:  ".current-area-size-select-menu",

  area_menu_toggle:   ".current-area-size-select-menu-dropdown-toggle",
  area_menu_dropdown: ".current-area-size-select-menu-dropdown",

  link: ".current-area-size-select-menu-dropdown-item-link",
}

class AreaSizeSelectMenu extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery
  protected $main: JQuery

  protected $area_menu_toggle:    JQuery
  protected $area_menu_dropdown:  JQuery

  protected $link: JQuery

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)
    this.$main = this.$scope.find(this.selector.main)

    this.$area_menu_toggle =  this.$scope.find(this.selector.area_menu_toggle)
    this.$area_menu_dropdown = this.$scope.find(this.selector.area_menu_dropdown)

    this.$link = this.$scope.find(this.selector.link)

    this.bind_action()
  }

  protected created(){}


  protected bind_action() {
    this.$area_menu_toggle.on("click", () => {
      if ( this.$area_menu_dropdown.hasClass("active") ) {
        this.$area_menu_dropdown.removeClass("active")
      }
      else {
        this.$area_menu_dropdown.addClass("active")
      }
    })

    this.$link.each((_idx, el) => {
      const area_size_unit = $(el).data("area-size-unit")

      const new_url = URI(window.location)
      new_url.addSearch("current_area_size_unit", area_size_unit)

      $(el).attr("href", new_url.toString())
    })

    onClickOutside(this.$main[0] as HTMLElement, () => {
      this.$area_menu_dropdown.removeClass("active")
    })
  }

}

const Factory = {
  _instance: null as null | AreaSizeSelectMenu,

  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new AreaSizeSelectMenu(selector)
  },
}

export {
  Factory,
  AreaSizeSelectMenu,
}
